//@flow

import React from 'react';
import { connect } from 'react-redux';

import HighlightsEditor from '../Editors/Highlights';
import HighlightsViewer from '../Viewers/Highlights';

type Props = {
  highlights: Array<string>,
  isActiveEditor: boolean,
};

const Highlights = ({ highlights, isActiveEditor }: Props) =>
  isActiveEditor ? (
    <HighlightsEditor highlights={highlights} />
  ) : (
    <HighlightsViewer highlights={highlights} />
  );

const mapStateToProps = ({ trekOverview }) => ({
  isActiveEditor: trekOverview.activeEditor === 'HighlightsEditor',
});

export default connect(mapStateToProps)(Highlights);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/Highlights.jsx